import { FC } from 'react';
import { ProInput } from '../antd';
import SimpleFormDisabled from './subpage/disabled';
import SimpleFormItem from './subpage/simpleFormItem';
import { BaseSimpleFormProps, SimpleFormItemEnum } from './interface';
import { TextAreaProps } from 'antd/lib/input/TextArea';

export interface SimpleFormTextAreaProps extends BaseSimpleFormProps {
  textAreaProps?: TextAreaProps;
}
const simpleFormTextArea: FC<SimpleFormTextAreaProps> = props => {
  const { disabledRender, textAreaProps, form, ...restProps } = props;
  return (
    <SimpleFormItem {...restProps}>
      {textAreaProps?.disabled ? (
        <SimpleFormDisabled
          name={props.name}
          form={form}
          render={disabledRender}
        />
      ) : (
        <ProInput.TextArea {...textAreaProps} />
      )}
    </SimpleFormItem>
  );
};

simpleFormTextArea.displayName = SimpleFormItemEnum.SimpleFormTextArea;

export default simpleFormTextArea;
